<script>
	import {onMount, onDestroy} from 'svelte';
	import {fly,fade} from 'svelte/transition';
	import {quintOut, quadOut} from 'svelte/easing';
	import {push, pop, querystring} from 'svelte-spa-router'

	import {db, storage} from '../../../firebase';
	import {modalCanUseHistoryBack} from '../../../store';

	import Icon from '../../atoms/Icon.svelte';
	import cross from '../../../../public/assets/svg/24/cross.svg';
	import Loader from '../../atoms/Loader.svelte';
	import ModalTabs from './ModalTabs.svelte';
	import ModalIdea from './ModalIdea.svelte';
	import ModalChat from './ModalChat.svelte';

	import * as bodyScrollLock from "body-scroll-lock";
	
	export let params = {}; // grab id from URL param

	let modal;
	let modalContent;
	let touchStartPosition; 
	let touchEndPosition; 
	let activeIndex = 0;
	let modalFlyInDone = false;
	
	let docId = params.id;
	let idea;

	let ideaImageAbsolutePath;
	let authorData;
	let timestamp;
	let shareData;

	let tabs = [
		{label: 'Idea'},
		{label: 'Chat'}
	]

	const close = () => {
		modalContent.style.transition = 'none';
		$modalCanUseHistoryBack ? pop() : push('/');
	};

	const scrollModalToLatest = () => {
		// console.log('now scrolling');
		// modal.scrollTo(0, modal.offsetHeight)
		
		// scroll to bottom
		if(modalFlyInDone) {
			modal.scrollTop = modal.scrollHeight;
		}

		// scroll to top
		// modal.scrollTo(0, 0)
	}

	const getIdea = () => {
		const docRef = db.doc(`ideas/${params.id}`);
		docRef.onSnapshot((doc) => {
			idea = doc.data();
			getAuthorData();
			getIdeaImageAbsolutePath();
			convertTimestamp();
			setShareData();
    	})
	}

	const getAuthorData = () => {
        db.collection('users').doc(idea.uid).get().then((doc)=> {                             
            authorData = doc.data();
        }).catch((error)=> {error});
    }

	const getIdeaImageAbsolutePath = () => {
        const storageRef = storage.ref();
        storageRef.child(idea.media).getDownloadURL().then((url) => { 
            ideaImageAbsolutePath = url;
        });
    }

	const convertTimestamp = () => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const date = new Date(idea.timestamp.seconds * 1000);

        // return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()} / ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
        timestamp = `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
    }

	const setShareData = () => {
		shareData = {
			title: `Originea – ${idea.title}`,
			url: window.location.href
		}
	}

	onMount(() => {

		getIdea();

		// change tab if ?chat query param is present
		if($querystring === 'chat') activeIndex = 1;
		
		document.body.classList.add('modal-open');
		bodyScrollLock.disableBodyScroll(modal);

		modal.addEventListener("touchstart", function (event) {
			modalContent.style.transition = 'none';
			touchStartPosition = event.changedTouches[0].pageY;
		}, false);

		modal.addEventListener("touchmove", function (event) {
			if(event.changedTouches[0].pageY - touchStartPosition > 0 && modal.scrollTop === 0) {
				touchEndPosition = event.changedTouches[0].pageY - touchStartPosition;
			}
		}, false);

		modal.addEventListener("touchend", function (event) {
			if(touchEndPosition > window.innerHeight / 5) {
				close();
			} else {
				modalContent.style.transition = 'transform 250ms ease-out';
				touchEndPosition = 0;
			}
		}, false);

	});

	onDestroy(() => {
		document.body.classList.remove('modal-open');
		bodyScrollLock.enableBodyScroll(modal);
	});

	$: if(modalFlyInDone && activeIndex === 1) modal.scrollTop = modal.scrollHeight;

</script>

<style lang="scss" src="./Modal.scss"></style>

<div class="Modal" bind:this={modal}>
	<div class="Modal__content" bind:this={modalContent} role="dialog" aria-modal="true" style="transform: translate3d(0, {touchEndPosition}px, 0)" in:fly="{{ y: window.innerHeight, duration: 500, easing: quintOut}}" out:fly="{{ y: window.innerHeight, duration: 500, easing: quadOut}}" on:introend="{() => modalFlyInDone = true}">
		<!-- TODO: Make modal header a component -->
		<div class="Modal__header">
			<!-- TODO, insert Modal Tabs -->
			<ModalTabs {tabs} bind:activeIndex={activeIndex}></ModalTabs>
			<div class="Modal__close">
				<button on:click={close}>
					<Icon data={cross}></Icon>
				</button>
			</div>
		</div>
		{#if idea}
			{#if activeIndex}
				<ModalChat
					{docId}
					{idea}
					{authorData}
					{ideaImageAbsolutePath}
					on:closeModal={close}
					on:scrollModalToLatest={scrollModalToLatest}
					>
				</ModalChat>
			{:else}
				<ModalIdea
					{docId}
					{idea}
					{ideaImageAbsolutePath}
					{authorData}
					{timestamp}
					{shareData}
					bind:activeIndex={activeIndex}
					>
				</ModalIdea>
			{/if}
		{:else}
			<Loader></Loader>
		{/if}
	</div>
	<div class="Modal__background" on:click={close} transition:fade="{{ duration: 500 }}"></div>
</div>